import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetShowVistaDocenteFeatureFlag = (options = {}) => {
  const query = useApiQuery(
    ['feature-flag', 'show-vista-docente'],
    'schools',
    '/feature-flags/show_vista_docente',
    options,
    { authenticated: true, version: 5 }
  )

  return {
    isLoadingShowVistaDocenteFeatureFlag: query.isLoading,
    isFetchingShowVistaDocenteFeatureFlag: query.isFetching,
    showVistaDocenteFeatureFlag: query.data ?? null,
    errorShowVistaDocenteFeatureFlag: query.isError ? query.error : null,
    getShowVistaDocenteFeatureFlag: query.refetch
  }
}